import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    input,
    Input,
    InputSignal,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';

import { BehaviorSubject, Observable, of } from 'rxjs';

import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import { omit } from 'lodash-es';
import { FormTagListStyling } from '../../../entities/form-tag-list-style.entity';
import { FormValue } from '../../../entities/form-value.entity';
import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';
import { ShFormTagListComplexBaseComponent } from '../base-complex/form-tag-list-complex-base.component';
import { ShFormTagListBaseComponent } from '../base-simple/form-tag-list-base.component';
import { FormTagListActionItem } from './form-tag-list-action-item.class';

type SanitizeToStringFunction = (value: string, existingValues: string[]) => string;
type SanitizeToStringArrayFunction = (value: string, existingValues: string[]) => string[];

@Component({
    selector: 'sh-form-tag-list',
    templateUrl: './form-tag-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        ShFormGroupComponent,
        ShFormTagListComplexBaseComponent,
        ReactiveFormsModule,
        ShFormTagListBaseComponent,
        AsyncPipe
    ]
})
export class ShFormTagListComponent extends ShBaseFormComponent implements OnInit, OnDestroy {
    public internalError$: BehaviorSubject<string> = new BehaviorSubject('');

    @Output() duplicateValues: EventEmitter<FormValue<string>[]> = new EventEmitter<FormValue<string>[]>();

    @Input() placeholder?: string;
    @Input() duplicateErrorMsg!: string;
    @Input() styling: FormTagListStyling = { style: 'Default', modifiers: [], truncate: true };
    @Input() actionItem?: FormTagListActionItem;
    @Input() autocomplete = 'off';
    @Input() singleTag = false;
    @Input() caseSensitive = true;
    @Input() maxLength?: number;
    limitedButtons: InputSignal<boolean> = input(false);

    @Input() sanitizeFct: SanitizeToStringFunction | SanitizeToStringArrayFunction = (value: string) => value;
    @Input() autocompleteFct: (term: string) => Observable<string[]> = term => of([]);

    public emitDuplicates(duplicates: FormValue<string>[]): void {
        this.duplicateValues.emit(duplicates);
    }

    public onInternalError(error: string): void {
        this.internalError$.next(error);
        if (error) {
            this.control.setErrors({ ...this.control.errors, internal: '' });
        } else {
            const newErrors: ValidationErrors = omit(this.control.errors, 'internal');
            this.control.setErrors(Object.keys(newErrors).length > 0 ? newErrors : null);
        }
    }

    public ngOnDestroy(): void {
        this.internalError$.complete();
        super.ngOnDestroy();
    }
}
